import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconWindowsUnmaximize({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9h-8v2H9v8h8v-2h2V9zm-2 7h1v-6h-6v1h5v5zm-7-4h6v6h-6v-6z" fill={fill}/>
        </svg>
    );
}

export default IconWindowsUnmaximize;

